export default __webpack_public_path__ + "static/media/screen3.82a4923e.png";